jQuery(document).ready(function($) {
    /**
     * Function to move additional email address fields.
     */
    const moveAdditionalEmailField = function() {
        const field2 = $('.woocommerce-account #_wmep_email_2');
        const field3 = $('.woocommerce-account #_wmep_email_3');
        const field4 = $('.woocommerce-account #_wmep_email_4');
        const field5 = $('.woocommerce-account #_wmep_email_5');

        const accountEmailField = $('.woocommerce-account #account_email');

        // Account email field must exist
        if (accountEmailField.length !== 1) {
            return;
        }

        if (field2.length === 1) {
            const fieldRow2 = field2.closest('.form-row');
            fieldRow2.addClass('form-row-first');
        }
        if (field3.length === 1) {
            const fieldRow3 = field3.closest('.form-row');
            fieldRow3.addClass('form-row-first');
        }
        if (field4.length === 1) {
            const fieldRow4 = field4.closest('.form-row');
            fieldRow4.addClass('form-row-first');
        }
        if (field5.length === 1) {
            const fieldRow5 = field5.closest('.form-row');
            fieldRow5.addClass('form-row-first');
        }

        const additionalEmailFieldTarget = accountEmailField.closest('.form-row');

        // Rows must exist
        if (additionalEmailFieldTarget.length !== 1) {
            return;
        }

        // Remove for retail
        if (dalby.isTrade === 'no') {
            $('.woocommerce-account #_wmep_email_2, .woocommerce-account #_wmep_email_3, .woocommerce-account #_wmep_email_4, .woocommerce-account #_wmep_email_5')
                .closest('.form-row')
                .remove();
            return; // No need to proceed further
        }

        // Move to a suitable location
        if (field5.length === 1) {
            additionalEmailFieldTarget.after(field5.closest('.form-row'));
        }
        if (field4.length === 1) {
            additionalEmailFieldTarget.after(field4.closest('.form-row'));
        }
        if (field3.length === 1) {
            additionalEmailFieldTarget.after(field3.closest('.form-row'));
        }
        if (field2.length === 1) {
            additionalEmailFieldTarget.after(field2.closest('.form-row'));
        }

        $('body').trigger('hide_show_emails');
    };

    // MutationObserver to watch for changes in .woocommerce-EditAccountForm
    const targetNode = document.querySelector('.woocommerce-EditAccountForm');

    if (targetNode) {
        const observer = new MutationObserver((mutationsList) => {
            observer.disconnect(); // Temporarily disconnect to avoid loops
            moveAdditionalEmailField();
            observer.observe(targetNode, { childList: true, subtree: true }); // Reconnect after changes
        });

        observer.observe(targetNode, {
            childList: true,
            subtree: true,
        });

    }

    // Run the function initially
    moveAdditionalEmailField();
});
